import { render, staticRenderFns } from "./windowSegurosClienteComponent.vue?vue&type=template&id=3060550e&scoped=true&"
import script from "./windowSegurosClienteComponent.vue?vue&type=script&lang=js&"
export * from "./windowSegurosClienteComponent.vue?vue&type=script&lang=js&"
import style0 from "./windowSegurosClienteComponent.vue?vue&type=style&index=0&id=3060550e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060550e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VCol,VContainer,VImg,VRow,VTooltip})
